module.exports = __webpack_public_path__ + "img/Klachtregistratie.53fceffe.png";